import cn from "classnames";
import { StatusProps } from "./types";
import styles from "./styles.module.scss";

export const Status = ({
  text,
  className,
  textOnly = false,
  type = "default",
  dataTestId = "status",
}: StatusProps) => (
  <div className={cn(styles.status, className)} data-test-id={dataTestId}>
    {!textOnly && (
      <div
        className={cn(styles["status-circle"], styles[`${type}-circle`])}
        data-test-id={`${dataTestId}-circle`}
      />
    )}
    <span
      className={cn(styles["status-text"], styles[`${type}-text`])}
      data-test-id={`${dataTestId}-text`}
    >
      {text}
    </span>
  </div>
);
